import { Link, useSearchParams } from "react-router-dom";
import Button from "../../../components/Button";
import { useAuthentication } from "../../Authentication/context";
import PageShell from "./PageShell";
import { INSTALL_PATH, getResultMessage } from "./messages";

// Public page: HiBob's consent flow can land here on a browser with no session.
function Result() {
	const [searchParams] = useSearchParams();
	const { companyName } = useAuthentication();

	if (searchParams.get("status") === "connected") {
		return (
			<PageShell title="HiBob is connected.">
				<p>
					Your HiBob company is now linked to{" "}
					{companyName ? <strong>{companyName}</strong> : "your Traxxion account"}.
				</p>
				<Button color="primary" tag={Link} to="/">
					Go to Traxxion
				</Button>
			</PageShell>
		);
	}

	const { message, canRestart } = getResultMessage(searchParams.get("reason"));

	return (
		<PageShell title="HiBob wasn't connected">
			<p role="alert">{message}</p>
			{canRestart ? (
				<Button color="primary" tag={Link} to={INSTALL_PATH}>
					Start again
				</Button>
			) : (
				<Button color="primary" tag={Link} to="/">
					Go to Traxxion
				</Button>
			)}
		</PageShell>
	);
}

export default Result;
